export default {"src":"/_next/static/media/mobileMenuChevron.706eca57.svg","height":16,"width":10,"blurWidth":0,"blurHeight":0};